module.exports = "/images/ny-life2-14.jpg";